import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { VasAppFacade } from '../../vas/services/vas-app-facade.service';
import { ResetAction } from '../molecules/file-manager/file-manager.actions';
import { selectFileManagerSubmit } from '../molecules/file-manager/file-manager.selectors';

@Injectable()
export class FileManagerService {

    constructor(protected appFacade: VasAppFacade) {

    }

    get changesCount$(): Observable<number> {
        return this.appFacade.store.select(selectFileManagerSubmit)
            .map(result => result.save.length + result.remove.length);
    }

    submit(): void {

        this.appFacade.store.select(selectFileManagerSubmit)
            .take(1)
            .do(result => result.save.forEach(file => this.appFacade.objects.file.store.update(file)))
            .do(result => result.remove.forEach(file => this.appFacade.objects.file.store.remove(file)))
            .do(() => this.reset())
            .subscribe(
                () => {
                    // noop
                },
                error => this.appFacade.toast.toastDanger(error)
            );
    }

    cancel(): void {
        this.reset();
    }

    protected reset(): void {
        this.appFacade.store.dispatch(new ResetAction());
    }
}



// WEBPACK FOOTER //
// ./src/app/services/file-manager.service.ts